import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { SimyoRateService } from '../../services/simyo-rate.service';
import { SimyoService } from '../../services/simyo.service';
import { fiberIndirectTechnologies, mobileContractType, orderType, rateAvailableIn, fibraSpeeds, countriesAllowedWithPassport, listTypeOperation, brandPortability, stepsShowRatesByBrand } from 'src/app/shared/constantes';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SimyoShoppingCartService } from '../../services/simyo-shopping-cart.service';
import { Router } from '@angular/router';
import { SimyoOrderService } from '../../services/simyo-order.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DigoService } from 'src/app/services/digo.service';
import { SimyoGlobals } from '../../classes/simyo-globals';
import { Subscription, of } from 'rxjs';
import { setTotal } from '../redux/simyo.actions';
import { Store } from '@ngrx/store';
import { PermissionService } from 'src/app/shared/services/permission.service';
import { allPermissions } from 'src/app/shared/permissions';
import { Ipdv } from 'src/app/shared/models/pdvResponse';
import { distinctUntilChanged, map, mergeAll, pairwise, startWith, switchMap, take, tap } from 'rxjs/operators';
import { SimyoStepperService } from '../../services/simyo-stepper.service';

@Component({
    selector: 'app-simyo-rates',
    templateUrl: './simyo-rates.component.html',
    styleUrls: ['./simyo-rates.component.css', '../../../../assets/css/simyo-theme.css'],
    standalone: false
})
export class SimyoRatesComponent implements OnInit, OnDestroy {
    @Input() index = 0;
    @Input() fibraRate = '';
    @Input() showTypeContent = '';

    @Input() coberturaFormGroup;
    @Input() normalizadorFormGroup;

    @Input() set resultadoCobertura(val: FormGroup) {
        this.technology = val?.get('resultadoConsultaCobertura')?.value?.technology;
        this.commercial_deal = val?.get('resultadoConsultaCobertura')?.value?.commercial_deal;
    }

    @ViewChild('content') content: NgbModalRef;
    @ViewChild('rememberPrepaid') rememberPrepaid: NgbModalRef;
    @ViewChild('notAllowedPrepaid') notAllowedPrepaid: NgbModalRef;
    @ViewChild('questionPortability') questionPortability;
    @ViewChild('rememberChangeRate') rememberChangeRate: NgbModalRef;
    @Output() onChangeRate = new EventEmitter<any>();
    @Output() requestRemovePostpaidsLines = new EventEmitter();

    public typeOrder: any = null;
    public loaded: boolean = false;
    public showErrorRate: boolean = false;
    public showErrorAdditionalRate: boolean = false;
    public allRates: any;
    public matrix: any;
    public paramRates: any;
    //public bonosRates: any[] = [];
    public readyRates: any = {
        postpaid: [],
        prepaid: [],
        '': []
    };
    public allFibraRates: any[] = [];
    public fibraRates: any[] = [];
    public movilRates: any = {
        postpaid: [],
        prepaid: [],
        '': []
    };
    public diffVoice: any[] = [];
    public diffData: any[] = [];
    public showPostpaid: boolean = false;
    public showPrepaid: boolean = false;
    public formsData: any = null;
    public default_rate: any = null;
    public defaultDataIndex = 0;
    public defaultVoiceIndex = 0;
    public rateChanged: any;
    public rateChangedFtth: any;
    public changedIsPostpaid: boolean = false;
    public customRate: any = {
        price: 0,
        textFibra: '',
        textType: '',
        textRate: '',
        textNetflix: '',
        rates: {
            fibra: null,
            movil: null,
            netflix: null
            //bonos: []
        }
    };
    public currentVoiceIndex = -1;
    public currentDataIndex = -1;

    public ratesFormGroup: FormGroup;
    public rechargePrice: any;
    private allSubscription: Subscription[] = [];
    public onlyPrepaid = false;

    public orderType = orderType;
    public allPermissions = allPermissions;
    public mobileContractType = mobileContractType;
    public fiberIndirectTechnologies = fiberIndirectTechnologies;

    public customerData: any;
    public isAdditional: boolean = false;
    public order;
    public isNebaTechnology: boolean = false;
    public minimumMobilePrice = 7;
    public rateFtth = null;
    public bonosSelected = [];
    public foundNetflixRate = null;
    public rateChangedTerminal = null;
    public contRememberPrepaid = 1;

    //public broadbandSpeedSelected;
    public maxBroadbandSpeed = '0';

    public technology;
    public commercial_deal

    showRateOnOffer = true;
    isStand = false;
    allowed50GB = false;
    showIconAdditional = false;
    rateSelected;
    rateSelectedIndex: number;

    public currentIndex;

    @ViewChild('fibraRow', { static: false }) fibraRow!: ElementRef;
    @ViewChild('netflixBlock') netflixBlock!: ElementRef<HTMLDivElement>;
    buttonNetflixWidth: string = 'auto';
    buttonContinueWidth: string = '0px';
    buttonToConvergentWidth: string = 'auto';

    public allBonos;
    public bonosNetflixValid;
    netflixPlans = [
        {
            "bono_id": 0,
            "name": "Netflix",
            "plan": "Sin Netflix",
            "description": null,
            "product_code": null,
            "price": 0,
            "is_default": false,
            "unified_price": "broadband",
            "available_in": []
        }
    ];
    public simyoTVPlans;

    // Tabla comparativa planes Netflix
    displayedColumns = ['plan', 'descripcion'];
   

    planNetflixSelectedIndex = -1;
    planNetflixSelected;

    showSimyoTVBono = false;
    updatedBonuses = [];

    digiProviderId = 18;

    public orderRatesDigi: any = {
        postpaid: [],
        prepaid: [],
        '': []
    };

    constructor(
        public simyoService: SimyoService,
        public rateService: SimyoRateService,
        private shoppingCartService: SimyoShoppingCartService,
        private formBuilder: FormBuilder,
        private router: Router,
        public orderService: SimyoOrderService,
        private modalService: NgbModal,
        private digoService: DigoService,
        public simyoGlobals: SimyoGlobals,
        private store: Store<{ simyo: number }>,
        public permSv: PermissionService,
        public simyoStepperService: SimyoStepperService
    ) {

        this.ratesFormGroup = this.formBuilder.group({
            fibraRate: [this.fibraRate, Validators.required],
            dataRate: ['', Validators.required],
            voiceRate: ['', Validators.required],
            //bonosRate: new FormArray([]),
            movilType: ['', Validators.required],
            mobiles: [[]],
            rate: [''],
            netflixPlan: ['0'],
            simyoTVProductCode: [null]
        });
    }

    ngOnInit(): void {
        this.allSubscription.push(this.ratesFormGroup.get('fibraRate').valueChanges
            .pipe(
                startWith(null),
                distinctUntilChanged(),
                pairwise()
            )
            .subscribe(([valorAnterior, speed]) => {
                let customerSpeed = this.typeOrder != orderType.BROADBAND ? this.simyoService.getMaxFtthSpeed() : this.simyoService.getMaxBroadbandCustomer()?.speed;
                speed = this.typeOrder != orderType.BROADBAND ? speed : '';
                this.maxBroadbandSpeed = this.getMaxFtthSpeed(customerSpeed, speed);
                this.showCorrectFibraRates();
                this.getDiffRates(this.allRates);
                this.setShowMobileType(this.allRates);
            }));

        this.allSubscription.push(this.digoService.getPDV()
            .subscribe((data: Ipdv) => {
                if (data) {
                    this.isStand = !!Number(data.info?.isstand);
                }
            })
        );

        this.allSubscription.push(of(this.simyoService.getDataFromCustomer(), this.simyoService.getDataFromNotCustomer())
            .pipe(
                mergeAll(),
                tap((data: any) => {
                    if (data) {
                        if (parseInt(data.customer?.document_type_id) === 3) {
                            const nationalityId = data.customer?.nationality_id ?? data.customer_nationality_id;
                            this.onlyPrepaid = !countriesAllowedWithPassport.includes(parseInt(nationalityId));
                        }
                        if (parseInt(data.customer_doctype) === 3) {
                            this.onlyPrepaid = !countriesAllowedWithPassport.includes(parseInt(data.country));
                        }
                    }
                })
            )
            .subscribe()
        );

        this.allSubscription.push(this.simyoService.getTypeOrder()
            .subscribe((data: any) => {
                this.typeOrder = data;
                switch (this.typeOrder) {
                    case orderType.CONVERGENT:
                        break;
                    case orderType.BROADBAND:
                        this.clearValidations('dataRate');
                        this.clearValidations('voiceRate');
                        this.clearValidations('movilType');
                        break;
                    case orderType.MOBILE:
                        this.clearValidations('fibraRate');
                        break;
                }
            })
        );

        this.allSubscription.push(this.rateService.getRates()
            .pipe(
                switchMap((data: any) => {
                    if (!data) return of(null);
                    return this.simyoService.getCustomerData().pipe(
                        take(1),
                        switchMap((customerData: any) => {

                            const zipCode = customerData?.customer?.zip_code ?? customerData?.zip_code ?? null;
                            const is_client_active = customerData?.is_client_active || 0;
                            const mobile_can_package = customerData?.mobile_can_package || 0;
                            let has_max_mobile = customerData?.max_mobile != null ? 1 : 0;
                            let has_max_broadband = customerData?.max_broadband != null ? 1 : 0;
                            let speed_max_broadband = customerData?.max_broadband?.speed || null;
                            let is_portability_other_brand = this.orderService.getIsPortabilityOtherBrand() != null ? brandPortability.digi : null;
                            let provider_id = null;
                            this.simyoService.getSelectedOperator().subscribe(operator => { provider_id = operator?.service_provider_id ?? null;});
                            let is_special_300 = this.simyoService.getIsSpecial300Reduced();

                            const needsSecondCall =
                                this.typeOrder === orderType.CONVERGENT &&
                                data.RATES?.MOBILE?.[0]?.default_selected;

                            if (needsSecondCall && zipCode) {
                                return this.rateService.getRatesFromService(zipCode, this.typeOrder, has_max_mobile, has_max_broadband, speed_max_broadband, is_client_active, mobile_can_package, is_special_300, is_portability_other_brand, provider_id).pipe(
                                    map((result: any) => {
                                        if (result?.msg) {
                                            this.rateService.setRates(result.msg);
                                            return { finalData: result.msg, zipCode };
                                        }
                                        return { finalData: data, zipCode };
                                    })
                                );
                            } else {
                                return of({ finalData: data, zipCode });
                            }
                        })
                    );
                })
            ).subscribe({
                next: ({ finalData }) => {

                    if (finalData) {
                        this.isNebaTechnology = this.simyoService.getNebaNoCommercial();
                        this.matrix = finalData;
                        this.allRates = this.rateService.determineRates(finalData);
                        this.allRates.FTTH_NEW = this.allRates.FTTH_NEW.map(rate => ({ ...rate, frontShowBroadband: true }));
                        this.paramRates = finalData.PARAMS;
                       
                        
                        this.allBonos = finalData.BONOS;
                        this.simyoTVPlans = this.allBonos?.simyo_TV ?? [];


                        this.loadData();
                        this.loaded = true;
                    }
                }
            })
        );



        this.allSubscription.push(this.simyoService.getCustomerPromotion()
            .subscribe((data) => {
                this.customerData = data;
                this.remove100MB(this.allRates);
                this.loadData();

            })
        );

        this.allSubscription.push(this.orderService.getOrder()
            .subscribe((order) => {
                if (order) {
                    this.order = order;
                    if (order.broadband?.rate_info?.speed && !this.showErrorRate && !this.isNebaTechnology) {
                        this.updateFtthRate(order.broadband.rate_info.speed.toString());
                    }
                }
            })
        );

        this.allSubscription.push(this.simyoService.getRatesMobile()
            .subscribe((data: any) => {
                if (this.index !== null && data && data[this.index] && this.allRates) {
                    this.setMobileRate(data[this.index]);
                    //this.setBonosRates(data[this.index].bonos);
                    this.ratesFormGroup.patchValue({ mobiles: data });
                }
            })
        );


        this.allSubscription.push(this.rateService.getErrorRate()
            .subscribe((data: boolean) => {
                this.showErrorRate = data;
            })
        );

        this.allSubscription.push(this.rateService.getErrorRateAdditional()
            .subscribe((data: boolean) => {
                this.showErrorAdditionalRate = data;
            })
        );

        // Retomar borrador
        this.allSubscription.push(this.simyoService.getFormsData()
            .subscribe((data: any) => {
                if (data != null) {
                    this.formsData = data;
                    this.updateShowSimyoTVBono();
                }
            })
        );

        this.allSubscription.push(this.simyoService.getRateFtth()
            .subscribe((data: any) => {
                this.rateFtth = data;
                let broadbandHasNoDiscount = this.simyoService.getMaxFtthSpeed();
                if (broadbandHasNoDiscount != '0') {
                    this.updateFtthRate(broadbandHasNoDiscount, false);
                }
            })
        );

        this.allSubscription.push(this.simyoService.getBonus()
            .subscribe((data: any) => {
                /**
                 * TODO: Hay que ver si viene cogido el BONO de simyo TV para saber si lo tenemos que mostrar.
                 */
                //esto es un array
                this.bonosSelected = data || [];

               
                const simyoTVBono = this.bonosSelected.find(b => b.name === 'simyo_TV');
                
                this.ratesFormGroup.patchValue({ simyoTVProductCode: simyoTVBono?.product_code ?? null }, { emitEvent: false });

                const netflixBono = this.bonosSelected.find(b => b.name === 'Netflix');

                if (netflixBono) {
                    //si es la misma que ya esta selecionada seguir
                    if(netflixBono.bono_id != this.ratesFormGroup.value.netflixPlan){
                        this.ratesFormGroup.patchValue({ netflixPlan: netflixBono.bono_id });

                        const index = this.netflixPlans.findIndex(p => p.bono_id === netflixBono.bono_id);
                        this.planNetflixSelectedIndex = index;
                        this.planNetflixSelected = this.netflixPlans[index];

                        this.foundNetflixRate = this.netflixPlans[index];
                    }
                    
                } else {
                    // Si no hay bono Netflix seleccionado, limpiar variables (coger la de por defecto)
                    this.planNetflixSelected = this.netflixPlans[0];
                    this.planNetflixSelectedIndex = 0;
                    this.foundNetflixRate = this.netflixPlans[0];
                    this.ratesFormGroup.patchValue({ netflixPlan: 0 });
                }
            })
        );

        if (this.simyoService.getIsChanging()) {
            this.allSubscription.push(this.simyoService.getRatesMobile()
                .subscribe((data: any) => {
                    if (data && typeof data[this.index] !== 'undefined') {
                        this.rateChanged = data[this.index];
                        this.rateChangedTerminal = data[this.index].terminal;
                        this.changeMobileType(this.rateChanged?.type_pay);
                    }
                })
            );

            if (this.rateChanged?.type_pay && this.rateChanged?.type_pay === 'postpaid') {
                this.changedIsPostpaid = true;
            }

            /*if (this.typeOrder === orderType.CONVERGENT && this.index === 0) {
                this.allSubscription.push(this.simyoService.getRateFtth()
                .subscribe((data: any) => {
                    if (data) {
                        this.rateChangedFtth = data;
                        this.updateFtthRate(this.rateChangedFtth.rate_info.speed.toString());
                    }
                })
                );

            }*/
        }

        this.allSubscription.push(this.rateService.getShowRateOnOffer()
            .subscribe((data) => {
                if (data && data.index === this.index) {
                    this.showRateOnOffer = data.status;
                }
                if (this.isStand) {
                    this.showRateOnOffer = true;
                }
                if (this.typeOrder === orderType.CONVERGENT && this.index === 0) {
                    this.showRateOnOffer = false;
                }

                let provider_id = this.simyoService.getSelectedOperator().pipe(map((operator: any) => operator?.service_provider_id ?? null)).subscribe();
                if (this.simyoService.getIndexMainLine() < 0 || this.simyoService.getIndexMainLine() == this.index || (this.orderService.getIsPortabilityOtherBrand() == 'antidigi' && provider_id != this.digiProviderId)) {
                    this.showRateOnOffer = false;
                }
            })
        );

        this.currentIndex = this.simyoStepperService.getCurrentStep();
    }

    ngAfterViewInit() {
        // Stepper del wizard se registra en AfterViewInit del padre; recalcular TV bono cuando ya existe
        setTimeout(() => {
            this.updateShowSimyoTVBono();
            this.setButtonWidth();
        });
    }

    private updateShowSimyoTVBono(): void {
        this.showSimyoTVBono = this.simyoService.isShowSimyoTVBono();
    }

    // Calcula el ancho del botón continuar para solo fibra
    setButtonWidth() {
        if (!this.fibraRow) return;

        const rowEl = this.fibraRow.nativeElement as HTMLElement;

        // Si quieres que el botón ocupe exactamente la "parte ocupada por las columnas visibles"
        const visibleCols = Array.from(rowEl.children)
            .filter((c: any) => (c as HTMLElement).offsetParent !== null) as HTMLElement[];

        if (visibleCols.length === 0) {
            this.buttonNetflixWidth = '0px';
            this.buttonContinueWidth = '0px';
            this.buttonToConvergentWidth = '0px';
            return;
        } else if (visibleCols.length === 1 && this.netflixBlock) {
            // Si solo hay un elemento y existe el bloque de Netflix, usar el ancho del bloque Netflix
            const netflixEl = this.netflixBlock.nativeElement;
            const width = netflixEl.getBoundingClientRect().width;
            this.buttonNetflixWidth = 'auto';
            this.buttonContinueWidth = width + 'px';
            this.buttonToConvergentWidth = width + 'px';
            return;
        }

        const first = visibleCols[0].getBoundingClientRect();
        const last = visibleCols[visibleCols.length - 1].getBoundingClientRect();

        // Si hay 3 columnas de precios, se calcula el ancho total desde la primera columna visible hasta la última 
        // (incluyendo gaps)
        this.buttonNetflixWidth = (last.right - first.left) + 'px';
        this.buttonContinueWidth = (last.right - first.left) + 'px';
        this.buttonToConvergentWidth = (last.right - first.left) + 'px';
    }

    ngOnDestroy() {
        if (this.allSubscription && this.allSubscription.length) {
            this.allSubscription.map(subs => subs.unsubscribe());
        }
        //this.simyoService.setchangeRateCart(false);
    }

    loadData() {
        //this.showCorrectFibraRates();
        if (this.typeOrder && this.allRates) {
            this.getDiffRates(this.allRates);
            this.showCorrectFibraRates();
            this.initForm();
            this.setShowMobileType(this.allRates);
        }
    }

    setShowMobileType(rates) {
        if (!rates) return;
        let type = rateAvailableIn.mobile;
        if (rates && rates.MOBILE) {
            if (this.typeOrder === orderType.CONVERGENT && this.index === 0) {
                type = this.simyoGlobals.getAvailableIn(this.customRate.rates.fibra?.rate_info.speed ?? '600');
            }
            if (this.typeOrder === orderType.MOBILE || (this.typeOrder === orderType.CONVERGENT && this.index > 0) && this.customRate) {
                type = rateAvailableIn.mobile;
            }

            const thereIsPostpaid = [...new Set(this.movilRates[mobileContractType.postpaid])];

            const thereIsPrepaid = [...new Set(this.movilRates[mobileContractType.prepaid])];

            this.showPostpaid = thereIsPostpaid.length ? true : false;
            let currentIndex = this.simyoStepperService.getCurrentStep();
            this.showPrepaid = (this.orderService.getIsPortabilityOtherBrand() == null
                || ((this.orderService.getIsPortabilityOtherBrand() !== null || (!this.orderService.getIsPortabilityOtherBrand() && this.orderService.getCpOtherBrand()))
                    && stepsShowRatesByBrand[brandPortability.digi]().includes(currentIndex) == false))
                && thereIsPrepaid.length
                && ((!this.isNebaTechnology || this.isAdditional) ? true : false);
            if (this.typeOrder === orderType.CONVERGENT && this.showPrepaid
                && stepsShowRatesByBrand[brandPortability.digi]().includes(currentIndex)) {
                //Si es cliente nuevo o no tiene linea con la que pueda paquetizar (>=7) no mostramos prepagos
                if (this.isNewCustomer() || this.simyoService.getMaxMobileCustomer() == null) {
                    this.showPrepaid = false;
                }
            }

            if (this.hasMobileSelection()) {
                this.evaluateActiveOptions();
                this.evaluateCustomRate(this.ratesFormGroup.getRawValue());
            } else {
                this.initMovilType();
            }
        }
    }

    getDiffRates(rates) {
        if (!rates) return;
        // FIBRA
        if (rates && rates.FTTH_NEW) {
            this.allFibraRates = rates.FTTH_NEW;
        }
        if (this.typeOrder == orderType.BROADBAND) {
            return;
        }

        // BONOS
        // if (rates.BONOS) {
        //     this.bonosRates = rates.BONOS;
        //     this.bonosRates.map(x => (this.ratesFormGroup.get('bonosRate') as FormArray).push(new FormControl(false)));
        // }
        // Cuando hay que mostrar adicionales? Si hay linea principal y más de una linea pospago
        //if((this.simyoService.getMainLine() !== null && this.simyoService.getIndexMainLine() !== this.index)
        //|| (this.typeOrder === orderType.CONVERGENT && this.simyoService.getMainLineWithoutSpeed() !== null && this.simyoService.getMaxBroadbandCustomer() == null )) {
        let mainLineMatrix = this.simyoService.searchMainLineInMatrix(this.simyoService.getMainLineWithoutSpeed());
        //Caso para comprobar si tiene solo un movil no mostrar adicionales, ya que no tiene fibra.
        let checkOrderType = this.typeOrder === orderType.MOBILE ? this.simyoService.customerHasPackageOrMainLine() : true;

        if (mainLineMatrix !== undefined
            && mainLineMatrix !== null
            && (this.checkRateAvailableIn(mainLineMatrix.rate_info.available_in) || this.simyoService.customerHasPackage())
            && (this.simyoService.getTotalMobileLines() > 1
                || this.simyoService.getIndexMainLine() !== this.index)
            && checkOrderType) {
            this.isAdditional = true;
            //Show additionals
            this.showAdditionalsRates(rates, mobileContractType.postpaid);
            this.showAdditionalsRates(rates, mobileContractType.prepaid);
            this.showReadyAdditionalsRates(rates, mobileContractType.postpaid)
        } else {
            this.isAdditional = false;
            let ratesTmp = this.showRates(rates);
            this.movilRates[mobileContractType.postpaid] = ratesTmp.postpaid;
            this.movilRates[mobileContractType.prepaid] = ratesTmp.prepaid;
            this.readyRates[mobileContractType.postpaid] = this.showReadyRates(this.matrix, mobileContractType.postpaid);
        }
        this.searchDefaultRate(true);

        // READY TO GO
        this.readyRates[mobileContractType.prepaid] = this.showReadyRates(this.matrix, mobileContractType.prepaid);
    }

    checkIfExistPriceIntoBroadband(rate_info: any, speed_price: any) {
        if (!rate_info || !speed_price || speed_price == "0") {
            return true;
        }

        return rate_info[`ftth_${speed_price}_price`] !== undefined
            && rate_info[`ftth_${speed_price}_price`] !== null
            && rate_info[`ftth_${speed_price}_price`] !== '';
    }

    initForm() {
        if (this.typeOrder === orderType.BROADBAND || (this.typeOrder === orderType.CONVERGENT && this.index === 0)) {
            this.initFibraRate();
            this.showBonos(this.allBonos);
        }

        if (this.typeOrder === orderType.MOBILE || (this.typeOrder === orderType.CONVERGENT && this.index > 0)) {
            this.initMobileRate();
        }

        this.evaluateCustomRate(this.ratesFormGroup.getRawValue());
    }

    // Inicializamos la tarifa por defecto de móvil
    initMobileRate() {
        let mobileType = this.ratesFormGroup.get('movilType').value;
        // Tarifa por defecto
        if (this.movilRates[mobileType] && this.movilRates[mobileType].length) {
            // Buscamos una por defecto
            let type = rateAvailableIn.mobile;
            if (this.typeOrder === orderType.CONVERGENT && this.index === 0) {
                type = rateAvailableIn.broadband_300;
            }
            if (this.typeOrder === orderType.MOBILE || (this.typeOrder === orderType.CONVERGENT && this.index > 0)) {
                type = rateAvailableIn.mobile;
            }
            const compatibleRateDefault = this.movilRates[mobileType];
            const rateDefault = compatibleRateDefault.find(x => x.default_selected);

            if (rateDefault) {
                this.setMobileRate(rateDefault);
            } else {
                // Seleccionamos una de las listas para llevar
                if (compatibleRateDefault && compatibleRateDefault.length) {
                    this.setMobileRate(compatibleRateDefault[compatibleRateDefault.length - 1]);
                }
            }
        }

        this.initMovilType();
    }

    // Inicializamos la tarifa por defecto de fibra
    initFibraRate() {
        if (this.fibraRates && this.fibraRates.length) {
            const rateDefault = this.fibraRates.find(x => {
                if (this.fibraRate && this.fibraRate != '') {
                    return x.rate_info.speed === this.fibraRate;
                }

                return x.default_selected;
            });

            if (rateDefault) {
                this.rateSelected = rateDefault;
                this.rateSelectedIndex = this.fibraRates.findIndex((fibra) => fibra.rate_id === rateDefault.rate_id);
                this.updateFtthRate(rateDefault.rate_info.speed);
            } else {
                let speed = this.typeOrder === orderType.CONVERGENT ? fibraSpeeds.speed_1gb : '';
                this.updateFtthRate(speed);
            }
        }
    }

    initMovilType() {
        let mobileContractTypeSelected = '';
        if (!this.showPostpaid && this.showPrepaid) {
            mobileContractTypeSelected = mobileContractType.prepaid;
        }

        if (this.showPostpaid && !this.showPrepaid) {
            mobileContractTypeSelected = mobileContractType.postpaid;
        }

        if (this.showPostpaid && this.showPrepaid) {
            mobileContractTypeSelected = '';
        }

        if (!this.showPostpaid && !this.showPrepaid) {
            mobileContractTypeSelected = '';
        }

        // Flujo movil con pasaporte solo se muestra prepago
        if (this.typeOrder == orderType.MOBILE && this.onlyPrepaid) {
            this.showPostpaid = false;
            mobileContractTypeSelected = '';
        }

        this.changeMobileType(mobileContractTypeSelected)
    }

    fromPostpaidToPrepaid() {
        return (this.changedIsPostpaid && this.ratesFormGroup.get('movilType').value === 'prepaid' && !this.isAdditional && this.orderService.multiplePostpaids());
    }

    fromPrepaidToPostpaid() {
        return (!this.changedIsPostpaid && this.ratesFormGroup.get('movilType').value === 'postpaid' && !this.isAdditional && this.orderService.multiplePostpaids());
    }

    preSelectRate(rate, index) {
        this.rateSelected = rate;
        this.rateSelectedIndex = index;

        this.customRate.rates.fibra = rate;

        this.showBonos(this.allBonos);

        this.ratesFormGroup.patchValue({ fibraRate: rate.rate_info.speed.toString() });
    }

    continue() {
        // Si solo se muestra una fibra, al ser la única fibra, preseleccionarla automáticamente
        if (!this.rateSelected) {
            if (this.fibraRates?.length === 1 && this.fibraRates[0]?.frontShowBroadband) {
                this.rateSelected = this.fibraRates[0];
            }
            if (this.fibraRates?.length > 1) {

            }
        }
        this.selectRate(this.rateSelected, false);
    }

    selectRate(rate, isReadyToBuy) {
        if (this.simyoService.getIsChanging()
            && this.orderService.paquetiza(this.index)
            && this.orderService.multiplePostpaids()
            && ((this.orderService.calculateMaxPrice(true) == 0) && (rate.price < this.minimumMobilePrice || rate?.rates?.movil?.contract_type == 'prepaid'))) {
            this.orderService.orderShowChangePackagedOrderDialog(this.index, this.fromPrepaidToPostpaid())
                .afterClosed()
                .subscribe((confirm: boolean) => {
                    if (confirm) {
                        this.shoppingCartService.getStepper().selectedIndex = 0;
                        this.orderService.removeAllFromIndex(0);
                        //this.confirmRate(rate, isReadyToBuy);
                    }

                });
            return;
        }
        if (this.showTypeContent === orderType.BROADBAND && this.typeOrder === orderType.CONVERGENT) {
            let speed = rate.rates?.fibra?.rate_info?.speed ?? rate.rate_info.speed;
            let mainLine = this.simyoService.getMainLine();
            let maxCurrentSpeed = this.simyoService.getMaxBroadbandCustomer() !== null ? this.simyoService.getMaxBroadbandCustomer().speed : null;
            let speedCheck = (maxCurrentSpeed == fibraSpeeds.speed_1gb || speed == fibraSpeeds.speed_1gb) ? fibraSpeeds.speed_1gb : (+maxCurrentSpeed > +speed ? maxCurrentSpeed : speed);
            let mainLineMatrix = this.simyoService.searchMainLineInMatrix(mainLine);
            let mainLineDigiMatrix = this.simyoService.searchMainLineInMatrix(mainLine, true);
            if (mainLineMatrix != null) {
                let availableIn = mainLineMatrix.rate_info != null ? mainLineMatrix.rate_info.available_in.includes(`ftth_${speedCheck}`) : mainLineMatrix.rate_info.available_in.includes(`ftth_${speedCheck}`)
                if ((this.orderService.getIsPortabilityOtherBrand() != null || (!this.orderService.getIsPortabilityOtherBrand() && this.orderService.getCpOtherBrand())) && mainLineDigiMatrix) {
                    availableIn = mainLineDigiMatrix.rate_info != null ? mainLineDigiMatrix.rate_info.available_in.includes(`ftth_${speedCheck}`) : mainLineDigiMatrix.rate_info.available_in.includes(`ftth_${speedCheck}`)
                }
                if (availableIn == false && this.simyoService.customerHasPackage() == false) {
                    this.orderService.orderShowChangePackagedOrderDialog2(this.index).afterClosed()
                        .subscribe((confirm: boolean) => {
                            if (confirm) {
                                this.orderService.removeAllFromIndex(0);
                                this.confirmRate(rate, isReadyToBuy);
                            }
                        });
                    return;
                }
            }

        }

        this.simyoService.setBonus(this.bonosSelected);
        this.confirmRate(rate, isReadyToBuy);

    }

    // Funcion que se lanza al seleccionar una tarifa en cualquiera de los 3 flujos
    confirmRate(rate, isReadyToBuy) {
        let mobileType = this.ratesFormGroup.get('movilType').value;
        const newRate = JSON.parse(JSON.stringify(rate));
        this.rateService.setErrorRate(false);
        if (this.typeOrder === orderType.BROADBAND) {
            this.simyoService.setRateFtth(this.updateNewRate(newRate));
            this.shoppingCartService.getStepper().next();
        }
        //if (this.typeOrder === orderType.CONVERGENT && this.index === 0) {
        if (this.typeOrder === orderType.CONVERGENT && this.showTypeContent !== orderType.MOBILE) {

            let fibra = this.rateFtth;
            let movil = newRate.rates?.movil ?? this.ratesFormGroup.get('mobiles').value[this.index];

            if (this.showTypeContent == '' || this.showTypeContent === orderType.BROADBAND) {
                fibra = newRate.rates?.fibra ?? newRate;
                movil = newRate.rates?.movil ?? this.ratesFormGroup.get('mobiles').value[this.index];

                this.simyoService.setRateFtth(this.updateNewRate(fibra));
            }

            if (this.showTypeContent == '' || this.showTypeContent === orderType.MOBILE) {
                newRate.rates.movil.type_pay = mobileType || this.ratesFormGroup.get('movilType').value;
                //this.simyoService.addFirstRatesMobile({...newRate.rates.movil, bonos: newRate.rates.bonos});
                //let mobile = {...newRate.rates.movil, bonos: newRate.rates.bonos, terminal: newRate.rates?.terminal};
                let mobile = { ...newRate.rates.movil, terminal: newRate.rates?.terminal };
                this.simyoService.setRatesMobile(this.index, mobile, this.order);
            }

            this.simyoService.setRateFtth(this.updateNewRate(fibra));

            this.shoppingCartService.getStepper().next();
        }

        if (this.typeOrder === orderType.MOBILE || (this.typeOrder === orderType.CONVERGENT && this.showTypeContent === orderType.MOBILE)) {
            let movil = isReadyToBuy ? newRate : newRate.rates.movil;
            let firstPostpaid;
            let firstPostpaidIndex;

            this.order.mobiles.some((movil, index) => {
                if (movil?.contract_type === 'postpaid' && movil?.rate_ids?.special_first_line_refered !== "") {
                    firstPostpaid = movil;
                    firstPostpaidIndex = index;
                    return true;
                }
                return false;
            });


            if (this.typeOrder == orderType.CONVERGENT && this.isNewCustomer() && this.orderService.getIsPortabilityOtherBrand() == null && firstPostpaid != null && 
            firstPostpaidIndex !== this.index && movil.contract_type === 'postpaid' && (parseInt(firstPostpaid.price || '0', 10) < parseInt(movil.rate_info?.price || '0', 10)) 
            && !this.simyoService.getchangeRateCart() && JSON.parse(firstPostpaid?.rate.show_in).special_first_line == true) {
                this.simyoService.setchangeRateCart(true);
                this.modalService.open(this.rememberChangeRate, { size: 'md', centered: true, backdrop: 'static', keyboard: false });
            }

            if (isReadyToBuy) {

                newRate.type_pay = this.ratesFormGroup.get('movilType').value;
                //this.simyoService.setRatesMobile(this.index, {...newRate, bonos: [], terminal: this.rateChangedTerminal}, this.order);
                this.simyoService.setRatesMobile(this.index, { ...newRate, terminal: this.rateChangedTerminal }, this.order);
                if (this.typeOrder === orderType.CONVERGENT) {
                    this.simyoService.setRateFtth(this.updateNewRate(this.rateFtth));
                }
            } else {
                newRate.rates.movil.type_pay = mobileType || this.ratesFormGroup.get('movilType').value;
                //this.simyoService.setRatesMobile(this.index, {...newRate.rates.movil, bonos: newRate.rates.bonos, terminal: newRate.rates?.terminal}, this.order);
                this.simyoService.setRatesMobile(this.index, { ...newRate.rates.movil, terminal: newRate.rates?.terminal }, this.order);
                if (this.typeOrder === orderType.CONVERGENT) {
                    this.simyoService.setRateFtth(this.updateNewRate(this.rateFtth));
                }
            }
        }

        if (this.typeOrder === orderType.CONVERGENT && this.ratesFormGroup.get('movilType').value === mobileContractType.prepaid) {
            this.rechargePrice = this.rateService.getRechargePrice(+newRate.rates.movil.rate_info?.real_price);// + this.simyoGlobals.pricesBonos(newRate.rates.bonos));
            if (this.rechargePrice > 0) {
                this.modalService.open(this.content, { size: 'md', centered: true, backdrop: 'static', keyboard: false });
            }
        }

        if (this.typeOrder === orderType.MOBILE && this.ratesFormGroup.get('movilType').value === mobileContractType.prepaid) {
            this.rechargePrice = isReadyToBuy ? this.rateService.getRechargePrice(+newRate.rate_info?.real_price) : this.rateService.getRechargePrice((+newRate.rates.movil.rate_info?.real_price));// + this.simyoGlobals.pricesBonos(newRate.rates.bonos)));
            if (this.rechargePrice > 0) {
                this.modalService.open(this.content, { size: 'md', centered: true, backdrop: 'static', keyboard: false });
            }
        }
        this.simyoService.setIsChanging(false);

    }

    updateNewRate(fibra) {
        fibra.rate_id = fibra.type_normal.rate_id;
        fibra.rate_info.price = fibra.type_normal.price;

        if (this.simyoService.getShowFtthReduced() && fibra.type_discount && fibra.type_discount?.rate_id) {
            let mainLine = this.simyoService.getMainLineWithoutSpeed();
            let mainLineMatrix = null
            const brand = this.orderService.getIsPortabilityOtherBrand();
            if (brand !== null && (brand == 'Otros' || brand == 'antidigi') || (!brand && this.orderService.getCpOtherBrand())) {
                mainLineMatrix = this.matrix.RATES_BY_BRAND?.digi?.MOBILE.find(rate => rate.rate_info.product_code == mainLine?.rate_info?.product_code);
            }
            if (!mainLineMatrix && this.typeOrder !== orderType.BROADBAND) {
                mainLineMatrix = this.matrix.RATES.MOBILE.find(rate => rate.rate_info.product_code == mainLine?.rate_info?.product_code);
            }
            if (mainLineMatrix == null) {
                mainLineMatrix = mainLine;
            }

            let speed = Object.values(fibraSpeeds).includes(this.maxBroadbandSpeed) ? this.maxBroadbandSpeed : fibra.rate_info.speed;
            if ((mainLineMatrix && mainLineMatrix.rate_info.available_in.includes(`ftth_${speed}`)) || this.simyoService.customerHasPackage()) {
                fibra.rate_id = fibra.type_discount.rate_id;
                fibra.rate_info.price = fibra.type_discount.price;
            }
        }

        return fibra;
    }

    // Funcion que se llama para gestionar la informacion que se le pasa de la tarifa personalizada
    evaluateCustomRate(data) {
        this.initCustomRate();
        let mobileType = this.ratesFormGroup.get('movilType').value;
        // Tipo de línea móvil
        if (data.movilType && data.movilType !== '' && data.movilType !== '0') {
            this.customRate.textType = listTypeOperation.find(x => x.id == data.movilType)?.label;
        }
        let auxText = [];
        // Fibra
        if (data.fibraRate && data.fibraRate !== '' && this.index === 0) {
            var foundRate = this.fibraRates.find(rate => rate.rate_info.speed === data.fibraRate);
            if (foundRate) {
                if (this.typeOrder === orderType.BROADBAND) {
                    foundRate.rate_info.price = foundRate.type_normal.price;
                    foundRate.rate_id = foundRate.type_normal.rate_id;
                    let speed = Object.values(fibraSpeeds).includes(this.maxBroadbandSpeed) ? this.maxBroadbandSpeed : foundRate.rate_info.speed;
                    let mainLine = this.simyoService.getMainLine();
                    if ((mainLine !== null && this.simyoService.getShowFtthReduced())
                        || this.simyoService.getCustomer()?.num_ftth.total_ftth_discount < 3) {
                        let mainLineMatrix = this.simyoService.searchMainLineInMatrix(mainLine);
                        if ((mainLineMatrix !== undefined && mainLineMatrix !== null && mainLineMatrix.rate_info?.available_in.includes(`ftth_${speed}`))
                            || this.simyoService.customerHasPackage()) {
                            foundRate.rate_info.price = foundRate.type_discount.price;
                            foundRate.rate_id = foundRate.type_discount.rate_id;
                        }
                    }
                }

                const found = foundRate;
                if (this.showTypeContent == '') {
                    this.customRate.price += +found.rate_info.price.replace(/,/g, '.');
                }
                this.customRate.textFibra = found.rate_info.speed;
                this.customRate.textFibra += found.rate_info.speed >= 100 ? ' Mb' : ' Gb';
                this.customRate.rates.fibra = found;

                let index = this.fibraRates.findIndex(r => r.rate_id === found.rate_id);
                this.preSelectRate(found, index);

            }
        }
        // Tarifa movil
        // NO quitar !== null que hace validaciones con el 0
        if (data.dataRate !== null && data.dataRate !== ''
            && data.voiceRate !== null && data.voiceRate !== ''
            && this.diffVoice[+data.voiceRate] && this.diffData[+data.dataRate]) {
            const found = this.movilRates[mobileType]
                .filter(rate =>
                    rate.voice === this.diffVoice[+data.voiceRate].label &&
                    rate.data === this.diffData[+data.dataRate].label
                );

            if (found && found.length) {
                let auxFound: any;
                if (found.length > 1) {
                    if (this.customRate.rates.fibra) {
                        auxFound = found.find(rate => (mobileType === '' || rate.contract_type === mobileType) && rate.rate_info.available_in.includes(this.simyoGlobals.getAvailableIn(this.customRate.rates.fibra.rate_info.speed)));
                    } else {
                        auxFound = found.find(rate => (mobileType === '' || rate.contract_type === mobileType) && rate.rate_info.available_in.includes(rateAvailableIn.mobile));
                    }
                } else {
                    auxFound = found[0];
                }

                let priceconvergente = '';
                if (this.customRate.rates.fibra && this.showTypeContent == '') {
                    priceconvergente = this.simyoGlobals.getFtthPrice(this.customRate.rates.fibra.rate_info.speed);
                    if (auxFound?.rate_info[priceconvergente] && auxFound.rate_info[priceconvergente] !== '') {
                        this.customRate.price = 0;
                        this.customRate.price += +auxFound.rate_info[priceconvergente];
                    }
                } else if (auxFound) {
                    this.customRate.price += +auxFound.rate_info.real_price.replace(/,/g, '.');
                }

                // this.customRate.price += +auxFound.rate_info.price.replace(/,/g, '.');
                auxText.push(auxFound?.data, auxFound?.voice);
                this.customRate.rates.movil = auxFound;
                this.rateChanged = auxFound;
            }
        }
        // Bonos
        // if (this.customRate.rates.bonos && this.customRate.rates.bonos.length) {
        //     this.customRate.rates.bonos.forEach(bono => {
        //         auxText.push(bono.rate_info.description);
        //         this.customRate.price += +bono.rate_info.price;
        //     });
        // }

        // Netflix
        /*if (data?.netflixPlan && data?.netflixPlan !== '' && data?.netflixPlan !== '0') {*/

        if(this.bonosSelected && this.bonosSelected.length > 0){
            //En este caso coger dentro del array el que sea de Netflix
            if(this.showTypeContent != 'mobile'){
                const selectedNetflix = this.bonosSelected.find(bono => bono.name === 'Netflix');

                if (selectedNetflix) {
                    this.foundNetflixRate = this.netflixPlans.find(plan => plan.bono_id === parseInt(selectedNetflix.bono_id));
                }
    
                if (this.foundNetflixRate && this.foundNetflixRate.bono_id != 0) {
                    this.customRate.price += +this.foundNetflixRate.price;
                    this.customRate.textNetflix = `${this.foundNetflixRate.name} ${this.foundNetflixRate.plan}`;
                    this.customRate.rates.netflix = this.foundNetflixRate;
                }else{
                    this.customRate.price = null;
                    this.customRate.textNetflix = null;
                    this.customRate.rates.netflix = null;
                }
            }

            const selectedSimyoTVProductCode = this.ratesFormGroup.get('simyoTVProductCode').value;
            if(selectedSimyoTVProductCode && this.ratesFormGroup.get('simyoTVProductCode').value !== null && this.shoppingCartService.getStepper().selectedIndex === 0){
                const selectedSimyoTV = this.bonosSelected.find(bono => bono.product_code == selectedSimyoTVProductCode);
                if(selectedSimyoTV){
                    this.customRate.price += +selectedSimyoTV.price;
                    this.customRate.rates.simyoTV = selectedSimyoTV;
                }else {
                    this.customRate.price = null;
                    this.customRate.rates.simyoTV = null;
                }
            }
        }

        if (auxText && auxText.length) {
            this.customRate.textRate = auxText.join(' + ');
        }
    }
    // Funcion para mostrar que opciones de la configuracion están disponibles
    evaluateActiveOptions() {
        let type = rateAvailableIn.mobile;
        let mobileType = this.ratesFormGroup.get('movilType').value;

        if (this.customRate.rates.fibra) {
            type = this.simyoGlobals.getAvailableIn(this.maxBroadbandSpeed);
        }

        if (mobileType != null && mobileType != '') {
            let rateSelected = this.rateChanged ?? this.default_rate;

            let dataSelected = null;
            let voiceSelected = null;

            if (rateSelected !== undefined) {
                dataSelected = this.currentDataIndex > -1 ? this.diffData[this.currentDataIndex].label : rateSelected.data;
                voiceSelected = this.currentVoiceIndex > -1 ? this.diffVoice[this.currentVoiceIndex].label : rateSelected.voice;
            }

            if ((dataSelected !== null)) {

                // Obtenemos la tarifa de voz disponible para ese data
                const aux = this.movilRates[mobileType].filter(rate => rate.data === dataSelected);

                const auxOffer = this.movilRates[mobileType]
                    .filter(rate =>
                        rate.rate_info.available_in.includes(type) &&
                        rate.rate_ids[mobileType] !== '' &&
                        rate.data === dataSelected
                    );
                // Mostramos como deshabilitado si no lo encontramos

                this.diffVoice = this.movilRates[mobileType].map(item => {
                    let auxFound = aux.find(rate => rate.voice === item.voice);

                    return {
                        label: item.voice,
                        disabled: auxFound ? false : true,
                        isOffer: auxOffer.find(rate => rate.is_additional && rate.voice === item.voice && rate.rate_info?.old_price !== '') ? true : false,
                    };
                })
                    .reduce(this.filterByValue, [])
                    .sort(this.compare);
                if (aux && aux.length === 0) {
                    this.initMobileRate();
                    return;
                }
                // Si la voz que hay seleccionada esta deshabilitada coger la primera que no lo este
                if (this.diffVoice.find(x => x.label === voiceSelected && x.disabled)) {
                    this.currentVoiceIndex = this.diffVoice.findIndex(x => x.disabled === false);
                    this.changeVoice(this.currentVoiceIndex);
                    return;
                }
            }

            if (voiceSelected !== null) {
                // Obtenemos la tarifa de voz disponible para ese data
                // Mostramos como deshabilitado si no lo encontramos
                if( mobileType == 'postpaid') { this.showIconAdditional = false; }
                this.diffData = this.movilRates[mobileType]
                    .map(item => {
                        let isOffer = item.is_additional && item.rate_info?.old_price !== '';
                        if (this.showIconAdditional == false && mobileType == 'postpaid') {
                            this.showIconAdditional = isOffer;
                        }
                        return {
                            label: item.data,
                            disabled: false,
                            isOffer
                        };
                    })
                    .reduce(this.filterByValue, [])
                    .sort(this.compare);
            }


            this.defaultDataIndex = this.diffData.findIndex(x => x.label === dataSelected);
            this.defaultVoiceIndex = this.diffVoice.findIndex(x => x.label === voiceSelected);

            this.ratesFormGroup.patchValue({
                dataRate: this.defaultDataIndex,
                voiceRate: this.defaultVoiceIndex
            });
        }
    }

    filterByValue(accumulator, current) {
        const x = accumulator.find(item => item.label === current.label);

        if (!x) {
            return accumulator.concat([current]);
        } else {
            if (current.isOffer) {
                const foundIndex = accumulator.findIndex(item => item.label === current.label);
                if (foundIndex !== -1) {
                    accumulator[foundIndex].isOffer = current.isOffer;
                }
            }
            return accumulator;
        }
    }

    compare(a, b) {
        let labelA = parseInt(a.label.replace('MIN', '').replace('MB', '').replace('GB', ''), 10);
        let labelB = parseInt(b.label.replace('MIN', '').replace('MB', '').replace('GB', ''), 10);
        labelA = isNaN(labelA) ? 1 : labelA;
        labelB = isNaN(labelB) ? 1 : labelB;

        if (a.label.includes('ILIMIT')) {
            labelA = labelA * 1000000;
        } else if (a.label.includes('GB')) {
            labelA = labelA * 100;
        }

        if (b.label.includes('ILIMIT')) {
            labelB = labelB * 1000000;
        } else if (b.label.includes('GB')) {
            labelB = labelB * 100;
        }

        if (labelA < labelB) {
            return -1;
        }

        if (labelA > labelB) {
            return 1;
        }

        return 0;
    }

    // Funcion para añadir un bono a la tarifa
    // addBonoToCustomRate(rate, state) {
    //     if (state) {
    //         // Añadimos el bono si no está añadido
    //         const found = this.customRate.rates.bonos.find(x => rate.name === x.name);
    //         if (!found) {
    //             this.customRate.rates.bonos.push(rate);
    //         }
    //     } else {
    //         // Eliminamos ese bono de la tarifa
    //         if (this.customRate.rates.bonos && this.customRate.rates.bonos.length) {
    //             const found = this.customRate.rates.bonos.findIndex(x => x.rate_ids.postpaid === rate.rate_ids.postpaid);
    //             if (found !== -1) {
    //                 this.customRate.rates.bonos.splice(found, 1);
    //             }
    //         }
    //     }
    //     if (this.customRate.rates.bonos && this.customRate.rates.bonos.length) {
    //         this.customRate.rates.bonos.map(bono => {
    //             this.customRate.textRate += ' + ' + bono.rate_info.description;
    //             this.customRate.price += +bono.rate_info.price;
    //         });
    //     }

    //     this.evaluateCustomRate(this.ratesFormGroup.getRawValue());
    // }
    // Funcion que evalua si la tarifa de fibra es correcta dependiendo si es cliente o no

    showCorrectFibraRates() {
        this.fibraRates = this.allFibraRates.filter(x => {
            return true;
        }).sort((a, b) => {
            if (a?.rate_info?.speed === '1') {
                return 1;
            }
            if (b?.rate_info?.speed === '1') {
                return -1;
            }
            if (a?.rate_info?.speed < b?.rate_info?.speed) {
                return -1;
            }
            if (a?.rate_info?.speed > b?.rate_info?.speed) {
                return 1;
            }
            return 0;
        });

        let only1gb = false;

        if (this.typeOrder === orderType.BROADBAND || this.showTypeContent === orderType.BROADBAND) {
            only1gb = this.isNebaTechnology ? true : false;

        }

        this.fibraRates.forEach(rate => {
            rate.rate_info.price = rate.type_normal.price;
            rate.rate_id = rate.type_normal.rate_id;

            if (this.typeOrder === orderType.BROADBAND && this.simyoService.getCustomer()?.num_ftth.total_ftth_discount < 3) {
                let mainLineWithoutSpeed = this.simyoService.getMainLineWithoutSpeed();
                let mainLineMatrix = this.simyoService.searchMainLineInMatrix(mainLineWithoutSpeed);
                let speed = Object.values(fibraSpeeds).includes(this.maxBroadbandSpeed) ? this.maxBroadbandSpeed : rate.rate_info.speed;
                if ((mainLineMatrix !== undefined && mainLineMatrix !== null && mainLineMatrix.rate_info?.available_in.includes(`ftth_${speed}`)
                    || this.simyoService.customerHasPackage())) {
                    rate.rate_info.price = rate.type_discount.price;
                    rate.rate_id = rate.type_discount.rate_id;
                    only1gb = false;
                }
            }

            if (this.typeOrder !== orderType.BROADBAND && this.showTypeContent === orderType.BROADBAND) {
                if (this.simyoService.getMainLine() !== null && this.simyoService.getShowFtthReduced()) {
                    rate.rate_info.price = rate.type_discount.price;
                    rate.rate_id = rate.type_discount.rate_id;

                    only1gb = false;
                }
            }
        });

        if (only1gb) {
            this.fibraRates = this.fibraRates.filter(rate =>
                rate.rate_info.speed === "1"
            )
        }

    }

    changeMobileType(mobileType) {
        this.ratesFormGroup.patchValue({
            movilType: mobileType
        });

        //Buscamos la tarifa por defecto
        this.searchDefaultRate(false);

        this.changeData();
        this.changeVoice();
        this.rateChanged = null;

        if (this.typeOrder === orderType.CONVERGENT) {
            if (mobileType === 'prepaid'
                && this.rememberPrepaid
                && this.contRememberPrepaid
                && this.permSv.hasPermFromV2(allPermissions.simyo.permite_sell_prepaid_postpaid)
                && this.orderService.calculateMaxPrice() == 0) {
                this.contRememberPrepaid--;
                this.modalService.open(this.rememberPrepaid, { size: 'md', centered: true, backdrop: 'static', keyboard: false });
            }
        }
    }

    changeVoice(newData = null) {
        this.currentVoiceIndex = -1;
        if (newData !== null) {
            this.currentVoiceIndex = newData
        }

        this.evaluateActiveOptions();
        this.evaluateCustomRate(this.ratesFormGroup.getRawValue());
        this.setNewRate(this.diffData, this.ratesFormGroup.get('dataRate').value, 'dataRate');
    }

    changeData(newData = null) {
        this.currentDataIndex = -1;
        if (newData !== null) {
            this.currentDataIndex = newData;
        }

        this.evaluateActiveOptions();
        this.evaluateCustomRate(this.ratesFormGroup.getRawValue());
        this.setNewRate(this.diffVoice, this.ratesFormGroup.get('voiceRate').value, 'voiceRate');
    }

    private hasMobileSelection(): boolean {
        const dataRate = this.ratesFormGroup.get('dataRate')?.value;
        const voiceRate = this.ratesFormGroup.get('voiceRate')?.value;
        return this.rateChanged != null
            || this.currentDataIndex > -1
            || this.currentVoiceIndex > -1
            || (dataRate !== '' && dataRate != null && voiceRate !== '' && voiceRate != null);
    }

    isAvailableRate(fibra?) {
        if (fibra) {
            this.onChangeRate.emit(fibra);
            this.updateFtthRate(fibra.rate_info.speed);
            const index = this.fibraRates.findIndex(r => r.rate_id === fibra.rate_id);
            this.preSelectRate(fibra, index);
        }

        this.showBonos(this.allBonos);

        if (this.hasMobileSelection()) {
            this.evaluateActiveOptions();
            this.evaluateCustomRate(this.ratesFormGroup.getRawValue());
        } else {
            this.initMobileRate();
        }
    }

    setNewRate(data, actualValue, formName) {

        if (data[+actualValue]?.disabled) {
            const found = data.findIndex(item => !item.disabled);
            if (found !== -1) {
                this.ratesFormGroup.get(formName).patchValue(found);
            }
        }
    }

    switchToConvergent() {
        this.simyoService.setTypeOrder(orderType.CONVERGENT);
        this.simyoService.setPreventDestroy(true);
        this.simyoService.setRateFtth(null);
        if (this.formsData && this.formsData.fibra) {
            this.formsData.fibra = null;
            this.simyoService.setFormsData(this.formsData);
        }
        if (this.coberturaFormGroup) {
            this.simyoService.setCoberturaData(this.coberturaFormGroup);
        }
        if (this.normalizadorFormGroup) {
            this.simyoService.setNormalizadorData(this.normalizadorFormGroup);
        }
        this.store.dispatch(setTotal({ total: 0 }));
        this.router.navigate(['simyo/convergente']).then(() => {
            this.simyoService.setPreventDestroy(false);
        });
    }

    setMobileRate(rateMobile) {
        this.currentVoiceIndex = this.diffVoice.findIndex(x => x.label === rateMobile?.voice);
        this.ratesFormGroup.get('dataRate').patchValue(this.diffData.findIndex(x => x.label === rateMobile?.data));
        this.ratesFormGroup.get('voiceRate').patchValue(this.diffVoice.findIndex(x => x.label === rateMobile?.voice));
        if (rateMobile?.type_pay !== undefined) {
            this.changeMobileType(rateMobile?.type_pay);
        }
    }

    // setBonosRates(rateBonos) {
    //     rateBonos.map(item => {
    //         (this.ratesFormGroup.get('bonosRate') as FormArray).at(this.bonosRates.findIndex(x => x.name === item.name)).patchValue(true);
    //         this.addBonoToCustomRate(item, true);
    //     });
    // }

    clearValidations(nameForm: string) {
        this.ratesFormGroup.get(nameForm).clearValidators();
        this.ratesFormGroup.get(nameForm).setValidators([]);
        this.ratesFormGroup.get(nameForm).updateValueAndValidity();
    }

    private remove100MB(rates) {
        rates?.FTTH_NEW.find
        const indice = rates.FTTH_NEW?.findIndex(ftth => ftth.rate_info.speed === fibraSpeeds.speed_100);

        if (indice !== -1) {
            rates.FTTH_NEW[indice].frontShowBroadband = false;
        }
    }

    checkPermissions(type) {
        if (this.permSv.hasPermFromV2(allPermissions.simyo.permite_sell_prepaid_postpaid)) {
            return true;
        }
        if (type === 'postpaid' && this.permSv.hasPermFromV2(allPermissions.simyo.permite_sell_postpaid)) {
            if (this.ratesFormGroup.get('movilType').value !== type) {
                this.changeMobileType('postpaid');
            }

            return true;
        }

        if (type === 'prepaid' && this.permSv.hasPermFromV2(allPermissions.simyo.permite_sell_prepaid)) {
            if (this.ratesFormGroup.get('movilType').value !== type) {
                this.changeMobileType('prepaid');
            }
            return true;
        }

        return false;
    }

    showContent(typeOrder: string, firstItem = false) {
        if (this.showTypeContent) return this.showTypeContent === typeOrder;

        switch (typeOrder) {
            case orderType.BROADBAND:
                return this.typeOrder === orderType.BROADBAND;
            case orderType.MOBILE:
                return this.typeOrder === orderType.MOBILE;
            case orderType.CONVERGENT:
                return this.typeOrder === orderType.CONVERGENT && firstItem;
            default:
                return false;
        }
    }

    calculatePrice(customRate) {
        let total = customRate.price;
        let mobileType = this.ratesFormGroup.get('movilType').value;
        if (this.showTypeContent == ''
            && customRate.rates.fibra
            //&& mobileType == mobileContractType.postpaid
        ) {
            //let mainLine = this.simyoService.getMainLineWithoutSpeed();
            if (customRate?.textType !== 'Prepago' && this.simyoService.getShowFtthReduced()) {
                this.customRate.rates.fibra.rate_id = this.customRate.rates.fibra.type_discount.rate_id;
                this.customRate.rates.fibra.rate_info.price = this.customRate.rates.fibra.type_discount.price;
            } else {
                this.customRate.rates.fibra.rate_id = this.customRate.rates.fibra.type_normal.rate_id;
                this.customRate.rates.fibra.rate_info.price = this.customRate.rates.fibra.type_normal.price;
            }

            total = +this.customRate.rates.fibra.rate_info.price;

            if (customRate.rates.movil) {
                total += +customRate.rates.movil.rate_info.real_price;
            }
        }

        if (customRate.rates.movil && this.showTypeContent == orderType.MOBILE) {
            total = +customRate.rates.movil.rate_info.real_price;
        }

        if (customRate.rates.netflix) {
            total += +customRate.rates.netflix.price;
        }
        if (customRate.rates.simyoTV) {
            total += +customRate.rates.simyoTV.price;
        }

        return total;
    }

    getRatesPostpaid(rates, speed) {
        let mainLine = this.simyoService.searchMainLineInMatrix(this.simyoService.getMainLine());
        let maxBroadbandCustomer = this.simyoService.getMaxBroadbandCustomer();
        const filteredRates = rates.filter(rate =>
                rate.rate_info.available_in.includes(speed)
                && rate.rate_ids.postpaid !== ''
                && ((mainLine == null && maxBroadbandCustomer != null && this.paramRates.FTTH_ACTIVE.includes(this.maxBroadbandSpeed))
                    ? (rate.rate_info.old_price !== '' ? rate.rate_info.old_price : +rate.rate_info.price) >= this.minimumMobilePrice : true)
                && ((this.allowed50GB && rate.data == '50 GB' && rate.voice == 'ILIMITADOS' && JSON.parse(rate.show_in).special_first_line == false) || (this.checkIfExistPriceIntoBroadband(rate.rate_info, (this.simyoService.customerHasPackage() || this.paramRates.FTTH_ACTIVE.includes(this.maxBroadbandSpeed)) ? this.maxBroadbandSpeed : null)))
                && ((this.allowed50GB && rate.data == '50 GB' && rate.voice == 'ILIMITADOS' && JSON.parse(rate.show_in).special_first_line == false) || (this.typeOrder === orderType.CONVERGENT ? this.checkRateAvailableIn(rate.rate_info.available_in) : true))
        );

        return this.simyoService.resolvePostpaidRates(filteredRates, this.index);
    }

    getRatesPrepaid(rates, speed) {
        return rates
            .filter(rate =>
                rate.rate_info.available_in.includes(speed) &&
                rate.rate_ids.prepaid !== ''
            )
    }

    searchDefaultRate(calculateDefaultIndex) {
        let mobileType = this.ratesFormGroup.get('movilType').value;
        this.default_rate = this.movilRates[mobileType].filter(x => x.default_selected)[0];
        this.defaultDataIndex = 0;
        this.defaultVoiceIndex = 0;
        if (calculateDefaultIndex) {
            if (this.default_rate) {
                this.defaultDataIndex = this.diffData.findIndex(x => x.label === this.default_rate.data);
                this.defaultVoiceIndex = this.diffVoice.findIndex(x => x.label === this.default_rate.voice);
            }
            if (this.rateChanged) {
                this.defaultDataIndex = this.diffData.findIndex(x => x.label === this.rateChanged.data);
                this.defaultVoiceIndex = this.diffVoice.findIndex(x => x.label === this.rateChanged.voice);
            }
        }
    }

    foundAdditionalRate(allRates, rate, mobileType) {
        const maxSecondPrice = this.orderService.calculateMaxPrice(true);
        const mainLine = this.simyoService.getMainLine();
        const totalMobileLine = this.simyoService.getTotalMobileLines();
        //Identificar cual es la principal, la del cliente o la del pedido
        const customerMaxMobile = this.simyoService.getMaxMobileCustomer();
        const mainLineIsCurrentOrder = this.simyoService.getIndexMainLine() > -1;

        let price = rate.is_additional ? +rate.rate_info.old_price : +rate.rate_info.price;
        /**Para mostrar lineas adicionales siendo la PRINCIPAL se tiene en cuenta:
         *  1 - Tengamos linea principal y posible linea secundaria
         *  2 - Haya mas de una línea
         *  3 - Buscar el precio de la linea secundaria y que sea mayor  al de la tarifa
         *      Este caso se da si tenemos una linea principal 150GB + Ilim y otra linea de 30GB + Ilim
         *      Si modificamos la de 150GB nos deberia aparecer a precio normal 30GB + Ilim, 50GB + Ilim y 150GB + Ilim
         *      El resto si las seleccionamos pasarian a adicional y la de 30GB + Ilim pasaria a ser principal
         *  4 - La tarifa tenga una homologa en el listado de adicionales
        */
        if (mobileType == 'postpaid'
            && mainLine !== null
            && totalMobileLine > 1
            && price < maxSecondPrice
            && rate?.rate_info?.product_code != '410270'
            && rate.rate_ids.additional != ''
        ) {
            if (this.index === this.simyoService.getIndexMainLine()
                && +rate.rate_info.product_code == +mainLine?.rate_info?.product_code
            ) {
                return rate;
            }

            if (customerMaxMobile !== null
                && customerMaxMobile.is_additional == true
                && mainLineIsCurrentOrder == false
                && +rate.rate_info.product_code == customerMaxMobile.rate_info.product_code_refered) {
                return rate;
            }
            return allRates.ADDITIONALS.find(rateMobile => (rateMobile.rate_ids.postpaid == rate.rate_ids.additional || rateMobile.rate_ids.prepaid == rate.rate_ids.additional));
        }
        return null;
    }

    initCustomRate() {
        this.customRate = {
            ...this.customRate,
            price: 0,
            textFibra: '',
            textType: '',
            textRate: '',
            textNetflix: '',
            rates: {
                terminal: this.rateChangedTerminal
            }
        };
    }

    showAdditionalsRates(rates, mobileType) {
        if (rates && rates.ADDITIONALS) {
            const type = rateAvailableIn.mobile;
            let ratesAdditionals = this.getAuxRates(rates, mobileType);
            const auxdiffData = [...new Set(ratesAdditionals
                .filter(rate =>
                    rate.rate_info.available_in.includes(type) &&
                    rate.rate_ids[mobileType] !== ''
                )
                .map(rate => rate && rate['data'])
                .filter(rate => rate))];
            if( mobileType == 'postpaid') { this.showIconAdditional = false; }
            this.diffData = auxdiffData
                .map(item => {
                    let isOffer = this.getOffer(ratesAdditionals, 'data', item);
                    if (this.showIconAdditional == false && mobileType == 'postpaid') {
                        this.showIconAdditional = isOffer;
                    }
                    return {
                        isOffer,
                        label: item,
                        disabled: false
                    };
                })
                .sort(this.compare);

            const auxDiffVoice = [...new Set(ratesAdditionals
                .filter(rate =>
                    rate.rate_info.available_in.includes(type) &&
                    rate.rate_ids[mobileType] !== ''
                )
                .map(rate => rate && rate['voice'])
                .filter(rate => rate))];

            // Ponemos el ultimo elemento del array al principio
            auxDiffVoice.splice(0, 0, auxDiffVoice.splice(auxDiffVoice.length - 1, 1)[0]);

            this.diffVoice = auxDiffVoice
                .map((item: any) => {
                    return {
                        isOffer: false,
                        label: item,
                        disabled: false
                    };
                })
                .sort(this.compare);
            this.orderRatesDigi[mobileType] = ratesAdditionals.filter(
                (rate, index, self) =>
                  index === self.findIndex(r => r.name === rate.name && r.contract_type === rate.contract_type)
              );
            this.movilRates[mobileType] = ratesAdditionals;
        }
    }

    getAuxRates(rates, mobileType, index = 0) {
        //let speed = this.simyoService.getMaxFtthSpeed();
        let speed = this.maxBroadbandSpeed == '0' && this.typeOrder == orderType.CONVERGENT ? fibraSpeeds.speed_1gb : this.maxBroadbandSpeed;
        //Identificar cual es la principal, la del cliente o la del pedido
        const customerMaxMobile = this.simyoService.getMaxMobileCustomer();
        const indexMainLine = this.simyoService.getIndexMainLine();
        const mainLineIsCurrentOrder = indexMainLine > -1;
        let maxPrice = this.orderService.calculateMaxPrice(indexMainLine == this.index);
        this.allowed50GB = this.simyoService.allowedRate50GBNormalPrice();
        if (indexMainLine == this.index && customerMaxMobile !== null) {
            /*this.allowed25GB = this.simyoService.allowedRate25GBNormalPrice(true);
            let secondLine = null;
            if(this.allowed25GB) {
                secondLine = this.orderService.getSecondMainLine() ?? customerMaxMobile;
            } else {
                secondLine = this.orderService.getSecondMainLine();
            }*/
            let secondLine = this.orderService.getSecondMainLine() ?? customerMaxMobile;
            maxPrice = this.orderService.calculateMaxPrice(secondLine !== undefined && secondLine !== null);
        }

        if (mobileType == mobileContractType.postpaid) {
            let currentIndex = index != 0 ? index : this.currentIndex;
            let line = this.orderService.order.mobiles[currentIndex - 1];

            let postpaidRates = this.showRates(rates).postpaid.filter(rate => {
                return (+rate.rate_info.real_price > maxPrice
                    || (+rate.rate_info.real_price == maxPrice && mainLineIsCurrentOrder == false && customerMaxMobile !== null && customerMaxMobile.is_additional == true)
                    || (+rate.rate_info.real_price == maxPrice && mainLineIsCurrentOrder == true && indexMainLine == this.index)
                    || (line?.rate?.brand == 'digi' && this.isNewCustomer() ? (rate?.voice == 'ILIMITADOS' ? true : false) : true)
                );
            });


            let additionalsRates = rates.ADDITIONALS
            .filter(rateAdd => rateAdd.contract_type === mobileType)
            .filter(rateAdd => {
                return this.changeAdditionalToNormal(rateAdd, maxPrice, mainLineIsCurrentOrder, customerMaxMobile, indexMainLine) == false
                    && rateAdd.rate_info.available_in.includes(rateAvailableIn.mobile)
                    && rateAdd.rate_ids[mobileType] !== ''
            })
            let orderRates = this.orderRates([...additionalsRates, ...postpaidRates]);
            return orderRates;
        }

        return rates.ADDITIONALS
        .filter(rateAdd => rateAdd.contract_type === mobileType)
        .map(rateAdd => {
            if ((+rateAdd.rate_info.old_price > maxPrice
                || (+rateAdd.rate_info.old_price == maxPrice && mainLineIsCurrentOrder == false && customerMaxMobile !== null && customerMaxMobile.is_additional == true)
                || (+rateAdd.rate_info.old_price == maxPrice && mainLineIsCurrentOrder == true && indexMainLine == this.index))
                && rateAdd.rate_ids.refered != '') {
                let foundMobile = rates.MOBILE.find(rateMobile => rateMobile.rate_info.available_in.includes(`ftth_${speed}`) && (rateMobile.rate_ids.postpaid == rateAdd.rate_ids.refered || rateMobile.rate_ids.prepaid == rateAdd.rate_ids.refered));
                /**
                 * Si encontramos el movil en las tarifas normales, comprobar lo siguient:
                 * La tarifa maxima es la que traia el cliente o una del order
                 * Si es la del cliente comprobar si es adicional, si es asi mostrar a precio normal, ya que la que trae es a precio reducido
                 */
                if (foundMobile)
                    return foundMobile;
            }
            return rateAdd;
        });

    }

    getOffer(rates, type, item): boolean {
        if (rates) {
            const found = rates.find(rate => rate[type] === item && rate.is_additional && rate.rate_info?.old_price !== '');
            if (found) {
                return true;
            }
        }
        return false;
    }

    calculateOldPrice(customRate) {
        let movil = customRate.rates.movil;
        let movilRateInfo = movil.rate_info;
        if (movilRateInfo.old_price
            && movilRateInfo.old_price !== ''
            && movil.show_additional_for_stand == false
        ) {
            return `${movilRateInfo.old_price}€`;
        }
        return '';

    }

    showRateConfigurator() {
        this.showRateOnOffer = false;
    }

    showRates(rates) {
        // MOVILES
        if (rates && rates.MOBILE) {
            const type = rateAvailableIn.mobile;
            let calculateRatesPostpaid = this.getRatesPostpaid(rates.MOBILE, type);
            const ratesPostpaid = calculateRatesPostpaid.map(rate => {
                let additionalRate = this.foundAdditionalRate(rates, rate, mobileContractType.postpaid);
                if (additionalRate) {
                    return additionalRate;
                }
                return rate;
            });

            const auxdiffData = [...new Set(calculateRatesPostpaid
                .map(rate => rate && rate['data'])
                .filter(rate => rate))];

            this.diffData = auxdiffData
                .map(item => {
                    return {
                        label: item,
                        disabled: false,
                        isOffer: false,
                    };
                })
                .sort(this.compare);

            const auxDiffVoice = [...new Set(calculateRatesPostpaid
                .map(rate => rate && rate['voice'])
                .filter(rate => rate))];

            // Ponemos el ultimo elemento del array al principio
            auxDiffVoice.splice(0, 0, auxDiffVoice.splice(auxDiffVoice.length - 1, 1)[0]);

            this.diffVoice = auxDiffVoice
                .map((item: any) => {
                    return {
                        label: item,
                        disabled: false,
                        isOffer: false,
                    };
                })
                .sort(this.compare);

            //Tiene sentido filtrar las tarifas por prepaid
            const ratesPrepaid = this.getRatesPrepaid(rates.MOBILE, type);

            this.orderRatesDigi['postpaid'] = ratesPostpaid.filter(
                (rate, index, self) =>
                  index === self.findIndex(r => r.name === rate.name && r.contract_type === rate.contract_type)
              );
            return {
                postpaid: ratesPostpaid,
                prepaid: ratesPrepaid,
            };
        }
    }

    showReadyRates(rates, mobileType) {
        if (rates.READY_TO_GO) {
            let readyRates = rates.READY_TO_GO.filter(rate => rate.contract_type == mobileType);

            if (mobileType === mobileContractType.postpaid) {
                readyRates = this.simyoService.resolvePostpaidRates(readyRates, this.index);
            }

            return readyRates
                .filter(rate => this.isShowReadyToGo(mobileType, rate)
                )
                .map(rate => {
                    return {
                        ...rate,
                        contract_type: mobileType
                    };
                })
                .map(rate => {
                    if (mobileType == mobileContractType.postpaid && rate.is_additional == false) {
                        let additionalRate = this.foundAdditionalRate(this.allRates, rate, mobileContractType.postpaid);
                        if (additionalRate) {
                            return { ...additionalRate, rate_info: { ...additionalRate.rate_info, caption: rate.rate_info?.caption } };
                        }
                    }
                    return rate;
                })
                .sort((a, b) => {
                    if (+a.rate_info?.real_price < +b.rate_info?.real_price) {
                        return -1;
                    } else if (+a.rate_info?.real_price > +b.rate_info?.real_price) {
                        return 1;
                    } else {
                        return 0;
                    }
                });
            ;
        }
        return []
    }

    isShowReadyToGo(mobileType, rate) {
        return (mobileType === 'postpaid'
            ? ((rate.is_additional == false ? +rate.rate_info.price >= this.minimumMobilePrice : +rate.rate_info.prices.iva.old_price >= this.minimumMobilePrice)
                && (rate.brand == 'digi' ? ((rate.rate_info.old_price && rate.rate_info.old_price !== '' && !rate.show_additional_for_stand && this.rateService.checkIsAdditional(rate) ) || rate.rate_info.product_code == 410270) : true)
                && this.checkIfExistPriceIntoBroadband(rate.rate_info, this.maxBroadbandSpeed)
                && (this.typeOrder === orderType.CONVERGENT ? this.checkRateAvailableIn(rate.rate_info.available_in) : true)
            )
            : rate.contract_type == mobileType)
    }

    showReadyAdditionalsRates(rates, mobileType) {
        const maxPrice = this.orderService.calculateMaxPrice();
        let _readyAdditionals = rates.ADDITIONALS.filter(rate => rate.is_additional || rate.show_additional_for_stand);
        //Identificar cual es la principal, la del cliente o la del pedido
        const customerMaxMobile = this.simyoService.getMaxMobileCustomer();
        const mainLineIsCurrentOrder = this.simyoService.getIndexMainLine() > -1;

        const indexMainLine = this.simyoService.getIndexMainLine();

        let ratesStandard = this.showReadyRates(this.matrix, mobileType).filter(rate => ((+rate.rate_info.real_price > maxPrice || (this.index == indexMainLine && +rate.rate_info.real_price >= maxPrice))
            || (+rate.rate_info.real_price == maxPrice && mainLineIsCurrentOrder == false && customerMaxMobile !== null && customerMaxMobile.is_additional == true)));

        let _readyRates = _readyAdditionals.filter(rateAdd => {
            return false == (((+rateAdd.rate_info.old_price > maxPrice || (this.index == indexMainLine && +rateAdd.rate_info.old_price >= maxPrice))
                || (+rateAdd.rate_info.old_price == maxPrice && mainLineIsCurrentOrder == false && customerMaxMobile !== null && customerMaxMobile.is_additional == true))
                && rateAdd.rate_ids.refered != '');
        })
        _readyRates = this.orderRates([..._readyRates, ...ratesStandard]);
        this.readyRates[mobileType] = _readyRates
            .sort((a, b) => {
                if (+a.rate_info.real_price < +b.rate_info.real_price) {
                    return -1;
                } else if (+a.rate_info.real_price > +b.rate_info.real_price) {
                    return 1;
                } else {
                    return 0;
                }
            });
    }

    setBroadbandSpeed(speed) {
        //this.broadbandSpeedSelected = speed;
        //La fibra 100 tiene minimo de precio 10, resto de fibras su minimo es 7
        //this.minimumMobilePrice = this.broadbandSpeedSelected === fibraSpeeds.speed_100 ? 10 : 7;
    }

    getMaxFtthSpeed(currentSpeed, speedSelected) {
        if (currentSpeed == '1' || speedSelected == '1') return '1';
        return +currentSpeed > +speedSelected ? currentSpeed : speedSelected;
    }

    changeAdditionalToNormal(rateAdd, maxPrice, mainLineIsCurrentOrder, customerMaxMobile, indexMainLine) {
        return (+rateAdd.rate_info.old_price > maxPrice
            || rateAdd.is_additional == true && +rateAdd.rate_info?.old_price == +rateAdd.rate_info?.real_price
            || (+rateAdd.rate_info.old_price == maxPrice && mainLineIsCurrentOrder == false && customerMaxMobile !== null && customerMaxMobile.is_additional == true)
            || (+rateAdd.rate_info.old_price == maxPrice && mainLineIsCurrentOrder == true && indexMainLine == this.index && (customerMaxMobile != null ? customerMaxMobile.price > maxPrice : true)))
            && rateAdd.rate_ids.refered != '';
    }

    getOrderIndex<T>(array: T[], value: T): number {
        const index = array.indexOf(value);
        return index === -1 ? Number.MAX_SAFE_INTEGER : index; // Si no encuentra, asignar un valor alto
    }

    orderRates(rates) {
        const orderData = this.paramRates.RATE_DATA;
        const orderVoice = this.paramRates.RATE_VOICE;

        return rates.sort((a, b) => {
            // Comparar por broadband primero
            const broadbandA = this.getOrderIndex(orderData, a.data);
            const broadbandB = this.getOrderIndex(orderData, b.data);

            if (broadbandA === broadbandB) {
                // Si son iguales, comparar por voice
                const voiceA = this.getOrderIndex(orderVoice, a.voice);
                const voiceB = this.getOrderIndex(orderVoice, b.voice);
                return voiceA - voiceB; // Comparar por voice
            }

            return broadbandA - broadbandB; // Comparar por broadband
        });
    }

    updateFtthRate(speed, compareSpeed = true) {
        let currentSpeed = this.ratesFormGroup.get('fibraRate').value;
        this.maxBroadbandSpeed = compareSpeed ? this.getMaxFtthSpeed(speed, currentSpeed) : speed;
        if (this.maxBroadbandSpeed != currentSpeed && this.paramRates?.FTTH_ACTIVE.includes(this.maxBroadbandSpeed)) {
            let defaultSpeed = this.typeOrder === orderType.CONVERGENT ? fibraSpeeds.speed_1gb : '';
            let updateSpeed = this.paramRates.FTTH_ACTIVE.includes(this.maxBroadbandSpeed) ? this.maxBroadbandSpeed : (this.paramRates.FTTH_ACTIVE.includes(currentSpeed) ? currentSpeed : defaultSpeed);
            this.ratesFormGroup.get('fibraRate').patchValue(updateSpeed);
        }
    }

    checkRateAvailableIn(availableIn) {
        if (Object.values(fibraSpeeds).includes(this.maxBroadbandSpeed)) {
            return availableIn.includes(`ftth_${this.maxBroadbandSpeed}`);
        }
        return availableIn.filter(available => available.includes('ftth') > 0).length > 0;
    }

    showPortability() {
        this.questionPortability.open();
    }

    nextPortability(event: { answer: string, portabilityOperator: any, offerSelected: any }) {
        this.rateService.setAskPortability(true);
        this.orderService.setIsPortabilityOtherBrand(event.answer == 'accept' ? event.portabilityOperator.value : null, event.offerSelected);
        this.switchToConvergent();
    }


    

    isNewCustomer() {
        let customer = this.simyoService.getCustomer();

        if (customer == null) {
            return true;
        }

        let mobilesPostpaidCustomer = customer?.mobiles?.filter(mobile => mobile.contract_type === "postpaid");

        return mobilesPostpaidCustomer?.length < 1 && customer?.broadbands?.length < 1;

    }

    
    changeNetflixPlan(index): void {
        this.planNetflixSelected = this.netflixPlans[index];
        this.planNetflixSelectedIndex = index;
    
        const selectedId = parseInt(this.ratesFormGroup.get('netflixPlan')?.value, 10);
        const currentBonuses = this.bonosSelected || [];
        const bonusNotNetflix = currentBonuses.filter(b => b.name !== 'Netflix');
    
        this.foundNetflixRate = selectedId === 0 ? null : this.netflixPlans.find(plan => plan.bono_id === selectedId) || null;
    
        this.bonosSelected = this.foundNetflixRate ? [...bonusNotNetflix, this.foundNetflixRate] : bonusNotNetflix;
    
        this.ratesFormGroup.patchValue({ netflixPlan: selectedId },{ emitEvent: false } );
        this.evaluateCustomRate(this.ratesFormGroup.getRawValue());
    }



    changeSimyoTVPlan(productCode: string, checked: boolean): void {
        // 1. Traducir el toggle a un único valor en el formulario
        const newCode = checked ? productCode : null;
      
        this.ratesFormGroup.patchValue(
          { simyoTVProductCode: newCode },
          { emitEvent: false }
        );
      
        // 2. Resolver el bono concreto del plan activado
        const simyoTVBonus = newCode
          ? this.simyoTVPlans.find(b => b.product_code === newCode) ?? null
          : null;
      
        // 3. Quitar TODOS los bonos TV (no solo 710002) y dejar el seleccionado
        const tvCodes = this.simyoTVPlans.map(p => p.product_code);
        const bonusNoTv = (this.bonosSelected || []).filter(
          b => !tvCodes.includes(b?.product_code)
        );
      
        this.bonosSelected = simyoTVBonus ? [...bonusNoTv, simyoTVBonus] : bonusNoTv;
        
        // 5. Recalcular precio
        this.evaluateCustomRate(this.ratesFormGroup.getRawValue());
    }


    openModalNetflixTable(modal) {
        this.modalService.open(modal, { size: 'lg', centered: true });
    }

        
    showBonos(bonos: any) {
        const fibraSelected = this.customRate?.rates?.fibra?.rate_info?.product_code;
        this.bonosNetflixValid = bonos?.Netflix.filter(bono => {
        
            if (bono.unified_price === 'broadband') {
                if (!fibraSelected) return true;
                return bono.available_in.includes(fibraSelected);
            }

            // Cambiar esta condicion cuando la unificacion por precio sea otra
            return bono.available_in.includes(fibraSelected && bono.name === 'Netflix');
        });

        let defaultPlan = this.netflixPlans.find(plan => plan.bono_id === 0);

        this.netflixPlans = [defaultPlan, ...this.bonosNetflixValid];

        const stillValid = this.netflixPlans.some(p => p.bono_id === parseInt(this.ratesFormGroup.get('netflixPlan').value));

        if (!stillValid) {
            this.ratesFormGroup.patchValue({ netflixPlan: '0' });
            this.changeNetflixPlan(0);
        }
        
    }

    checkIsShowReady(){
        if(stepsShowRatesByBrand[brandPortability.digi]().includes(this.currentIndex) && this.allRates.MOBILE.length < 2) {
            return false
        } 
        return true;

    }

    

    bonoSimyoTVName(product_code): string {
        let bonoSimyoTv = this.allBonos?.simyo_TV.find((bono: any) => bono?.product_code === product_code);
        return bonoSimyoTv?.display_name ?? '';
    }

    formatSimyoTVPrice(price): string {
        return price?.toFixed(2)?.replace('.', ',') ?? '';
    }



    isSpecialDigi() {
        let provider_id = null;
        this.simyoService.getSelectedOperator().subscribe(operator => { provider_id = operator?.service_provider_id ?? null;});
        return this.orderService.getIsPortabilityOtherBrand() == 'antidigi' && provider_id == this.digiProviderId && this.ratesFormGroup.get('movilType').value  === 'postpaid';
    }

    isFirstLine() {
        let currentIndex = this.simyoStepperService.getCurrentStep();
        if((this.typeOrder == orderType.CONVERGENT || this.typeOrder == orderType.MOBILE) && currentIndex == 0){
            return true;
        }
        return false;
    }
    
}
